<template>
  <div>
    <div
      class="columns is-gapless has-background-white is-marginless-bottom is-border">
      <div class="column is-self-centered is-padding-right is-padding-left">
        <div class="is-self-centered is-padding-top-small is-padding-bottom-small">
          <span class="is-uppercase title is-6">Restitution cautions</span>
        </div>
      </div>
    </div>
    <div class="has-background-light is-padding">
      <div class="columns is-multiline">
        <div class="column is-6 is-4-widescreen">
          <date-picker
            :model="adv.degradation_deposit_date"
            class="is-self-centered"
            :field-class="'is-self-centered'"
            :input-class="'is-fullwidth'"
            :style-version="2"
            :is-required="false"
            label="Caution dégradations"
            @input="$store.commit('modifyCurrentAdv', { key: `degradation_deposit_date`, value: $event })" />
        </div>
        <div class="column is-6 is-4-widescreen">
          <date-picker
            :model="adv.other_degradation_deposit_date"
            class="is-self-centered"
            :field-class="'is-self-centered'"
            :input-class="'is-fullwidth'"
            :style-version="2"
            :is-required="false"
            label="Autre caution"
            @input="$store.commit('modifyCurrentAdv', { key: `other_degradation_deposit_date`, value: $event })" />
        </div>
        <div class="column is-6 is-4-widescreen">
          <date-picker
            :model="adv.fences_realisation_date"
            class="is-self-centered"
            :field-class="'is-self-centered'"
            :input-class="'is-fullwidth'"
            :style-version="2"
            :is-required="false"
            label="Caution conformité"
            @input="$store.commit('modifyCurrentAdv', { key: `fences_realisation_date`, value: $event })" />
        </div>
      </div>
      <div class="columns is-multiline is-border-top">
        <div class="is-self-centered is-4">
          <div class="is-padding-top-small is-padding-small">
            <div>
              <input
                id="hasPropertyTax"
                v-model="hasPropertyTax"
                name="hasPropertyTax"
                class="switch is-success is-rounded"
                type="checkbox"
                @input="togglePropertyTax(!hasPropertyTax)">
              <label
                for="hasPropertyTax"
                style="font-size: 12.5px"
                class="is-uppercase">Récupération de la taxe foncière</label>
            </div>
          </div>
        </div>
        <div
          v-if="hasPropertyTax"
          class="column is-4">
          <r-label
            :label="'Montant récupération taxe foncière'"
            :value="adv.property_tax_amount"
            :is-required="false" />
          <div class="field has-addons">
            <div class="control">
              <a class="button is-static is-border is-square">
                <span class="icon"><i class="fas fa-euro-sign" /></span>
              </a>
            </div>
            <div class="control is-expanded">
              <v-input
                id="property_tax"
                v-validate="'decimal:2'"
                name="property_tax"
                :model="adv.property_tax_amount"
                class=""
                :errors-bag="errors"
                data-vv-value-path="val"
                :number="true"
                input-type="number"
                data-vv-as="Montant récupération taxe foncière"
                @input="value => $store.commit('modifyCurrentAdv', { key: `property_tax_amount`, value })" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="isAdmin && isPromoteur || currentUser.active_all_contact"
      class="has-background-white is-border-top is-margin-top">
      <div class="row-width-actions-bar columns is-gapless is-marginless">
        <div class="column is-self-centered is-padding-left is-padding-top-xsmall is-padding-bottom-xsmall">
          <span class="is-uppercase title is-6">Commentaire</span>
        </div>
        <div class="column is-narrow is-border-left">
        </div>
      </div>
      <template v-if="openComment">
        <div
          v-if="!openCommentWysi && comment"
          @click="openWysiwyg"
          class="vadDiscussion is-border-top"
          style="cursor: pointer;">
          <div
            class="vadDiscussion--bulle is-size-6 is-minH50p vadDiscussion--bulle--has-actions is-cut is-padding-left">
            <div
              class="content"
              v-if="(isAdmin || currentUser.active_all_contact) && comment"
              v-html="comment"></div>
            <div class="actionsOnRow actionsOnRow--vertical">
              <div class="">
                <button
                  @click="openWysiwyg"
                  class="is-min-height-full">
                  <span class="icon is-small"><i class="fal fa-edit"></i></span>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          v-else
          class="is-border-top columns is-gapless">
          <div class="column">
            <wysiwyg-editor
              :light="true"
              :tooltip-top="true"
              :model="comment"
              @change="val => comment = val"
              class="editr--bottom-toolbar no-toolbar editr--height-small content is-borderless">
            </wysiwyg-editor>
          </div>
          <div class="actionsOnRow actionsOnRow--vertical">
            <div>
              <button
                @click="patchComment()"
                type="button"
                class="button"
                :class="[(baseComment !== comment) ? 'is-success' : 'is-info']"
                :disabled="(baseComment === comment)">
                <span class="icon is-small">
                  <i
                    v-if="loadComment"
                    class="fas fa-spinner fa-spin"></i>
                  <i
                    v-else
                    class="fal fa-save"></i>
                </span>
              </button>
            </div>
            <div class="">
              <button
                :disabled="!baseComment"
                type="button"
                :class="{'actionsOnRow-btn--hoverIsDanger': comment}"
                @click="comment?openCommentWysi = false:null; comment = baseComment">
                <span class="icon is-small"><i class="fal fa-times"></i></span>
              </button>
            </div>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { Adv } from '@/mixins'

export default {
  name: 'Livraison',
  components: {
  },
  mixins: [Adv],
  data () {
    return {
      dateTest: null,
      hasPropertyTax: false,
      numberTest: null
    }
  },
  computed: {
  },
  created () {
    if (this.adv.property_tax_amount) this.hasPropertyTax = true
  },
  methods: {
    togglePropertyTax (event) {
      if (event === false && this.adv.property_tax_amount) {
        this.adv.property_tax_amount = null
        this.$store.commit('modifyCurrentAdv', { key: `property_tax_amount`, value: null })
        this.hasPropertyTax = true
      } else {
        this.hasPropertyTax = !this.hasPropertyTax
      }
    }
  }
}
</script>
